
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/coming-soon",
      function () {
        return require("private-next-pages/[locale]/coming-soon/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/coming-soon"])
      });
    }
  